import React from 'react';
import {
  Gauge, LineChart, AreaChart, BarChart3, BarChartHorizontal, PieChart, Table2, Grid3x3, Type, Layers,
} from 'lucide-react';

const ICONS = {
  kpi: Gauge,
  line: LineChart,
  area: AreaChart,
  bar: BarChart3,
  stacked: Layers,
  hbar: BarChartHorizontal,
  pie: PieChart,
  table: Table2,
  pivot: Grid3x3,
  text: Type,
};

export function TypeIcon({ type, ...props }) {
  const Icon = ICONS[type] || BarChart3;
  return <Icon {...props} />;
}
